export { LicensesComponent } from '../components/licenses/licenses.component';
